import React from 'react';

import { Actions, Action, PlayArrowIcon, PauseIcon } from '@gogame/components';

export const MetricStatusActions = ({
  onPlay,
  onPause,
  onDelete,
  canPlay = true,
  canPause = true,
  canDelete = true,
}) => {
  return (
    <Actions limit={0}>
      {canPlay ? (
        <Action
          id={'play'}
          icon={<PlayArrowIcon />}
          label={'Start'}
          onClick={onPlay}
        />
      ) : null}
      {canPause ? (
        <Action
          id={'pause'}
          icon={<PauseIcon />}
          label={'Pause'}
          onClick={onPause}
        />
      ) : null}
      {canDelete ? (
        <Action
          id={'delete'}
          icon={<PauseIcon />}
          label={'Delete'}
          onClick={onDelete}
        />
      ) : null}
    </Actions>
  );
};
